import { Component, OnInit, Input } from '@angular/core';
import { TransportationReservation } from '../itineray.model';

@Component({
  selector: 'app-itinerary-reservations-transportation-form-title',
  templateUrl: './itinerary-reservations-transportation-form-title.component.html',
  styleUrls: ['./itinerary-reservations-transportation-form-title.component.css']
})
export class ItineraryReservationsTransportationFormTitleComponent implements OnInit {

  @Input()
  transportation: TransportationReservation;

  constructor() { }

  ngOnInit() {
  }

}
